import { LegacyPortalSearchEventType } from "@spwn-portal/grpc/build";

import type { State } from "../../../useFormState/types/states";

const LEGACY_PORTAL_SEARCH_EVENT_TYPE_VALUES = new Set(
  Object.values(LegacyPortalSearchEventType)
);
type EventType = State["eventType"]["checkboxData"][number];

export const extractCheckedEventTypesId = (
  previousValue: LegacyPortalSearchEventType[],
  eventType: EventType
): LegacyPortalSearchEventType[] => {
  const { checkboxId, isChecked } = eventType;
  if (!isChecked) return previousValue;
  const checkboxIdAsNumber = Number(checkboxId);
  if (!LEGACY_PORTAL_SEARCH_EVENT_TYPE_VALUES.has(checkboxIdAsNumber))
    return previousValue;
  previousValue.push(checkboxIdAsNumber);
  return previousValue;
};
